import Block from '../../common.blocks/block'

import debounce from 'lodash.debounce'

export default class Parcelshop extends Block {
	static title = 'parcelshop'

	constructor($el) {
		super($el)

		this.streetInput = this.$el.find('input[name="street"]')
		this.zipcodeInput = this.$el.find('input[name="zipcode"]')
		this.numberInput = this.$el.find('input[name="number"]')
		this.cityInput = this.$el.find('input[name="city"]')
		this.countryInput = this.$el.find('input[name="country_id"]')
		this.select = this.$el.findElement('select')
		this.parcelshopInfo = this.$el.findElement('info')
		this.loader = this.$el.findElement('loader')

		this.customerIdContainer = this.$el.findElement('customerid-container')
		this.customerIdInput = this.$el.findElement('customerid-input')
		this.customerCheck = this.$el.findElement('customer-check')
		this.customerMessage = this.$el.findElement('customerid-message')

		let street = null
		let zipcode = null
		let number = null
		let city = null
		let country = null

		this.button = $(document).find(
			'.shoppingcart-payment button[type="submit"]',
		)
		this.button.prop('disabled', true)

		const addressObserver = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes') {
					const newStreet = this.streetInput.attr(mutation.attributeName)
					const newZipcode = this.zipcodeInput.attr(mutation.attributeName)
					const newNumber = this.numberInput.attr(mutation.attributeName)
					const newCity = this.cityInput.attr(mutation.attributeName)
					const newCountry = this.countryInput.attr(mutation.attributeName)
					street = newStreet
					zipcode = newZipcode
					number = newNumber
					city = newCity
					country = newCountry

					this.getParcelshopsList(street, zipcode, number, city, country)
				}
			}
		})

		addressObserver.observe(this.streetInput.get(0), {
			attributes: true, // watch for attribute changes
		})

		this.select.on('change', () => {
			this.getParcelshop()
		})

		this.customerIdInput.change(
			debounce(() => this.updateCustomerId(), 500, {
				leading: true,
			}),
		)
	}

	getParcelshopsList(street, zipcode, number, city, country) {
		this.setLoading(true)
		this.button.prop('disabled', true)
		const payload = new FormData()

		payload.append('parcelshop_street', street)
		payload.append('parcelshop_zipcode', zipcode)
		payload.append('parcelshop_number', number)
		payload.append('parcelshop_city', city)
		payload.append('parcelshop_country', country)
		payload.append('parcelshop_shipping_id', 10)

		fetch('/parcelshop', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
				this.select.html(json.html)
				this.setLoading(false)
			})
			.catch((error) => {
				$(document).trigger('message:error', { message: error })
			})
	}

	getParcelshop() {
		this.setLoading(true)
		const payload = new FormData()

		payload.append('parcelshop_info', true)
		payload.append('parcelshop_id', this.select.val())

		fetch('/parcelshop', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
				this.parcelshopInfo.removeClass('parcelshop__info--hidden')
				this.parcelshopInfo.html(json.html)

				if (json.type == 'packStation') {
					this.customerIdContainer.removeClass(
						'parcelshop__customerid-container--hidden',
					)
					this.customerIdInput.prop('disabled', false)
					this.customerIdInput.parent().removeClass('mdc-text-field--disabled')
					if (this.customerIdInput.val().length < 1) {
						this.button.prop('disabled', true)
					}
				} else {
					this.customerIdContainer.addClass(
						'parcelshop__customerid-container--hidden',
					)
					this.customerIdInput.prop('disabled', true)
					this.customerIdInput.parent().addClass('mdc-text-field--disabled')
					this.button.prop('disabled', false)
				}

				$(document).trigger('total:next')

				this.setLoading(false)
			})
			.catch((error) => {
				$(document).trigger('message:error', { message: error })
			})
	}

	updateCustomerId() {
		this.customerMessage.removeClass('message--visible')
		const payload = new FormData()

		payload.append('change_customerid', true)
		payload.append('customer_id', this.customerIdInput.val())

		fetch('/parcelshop', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then(() => {
				if (this.customerIdInput.val().length < 1) {
					this.customerCheck.removeClass('parcelshop__customer-check--success')
					this.customerCheck.find('i').removeClass('fa-check')
					this.customerCheck.find('i').addClass('fa-xmark')
					this.customerMessage.addClass('message--visible')
				} else {
					this.customerCheck.addClass('parcelshop__customer-check--success')
					this.customerCheck.find('i').removeClass('fa-xmark')
					this.customerCheck.find('i').addClass('fa-check')
					this.customerMessage.removeClass('message--visible')
					this.button.prop('disabled', false)
				}
				$(document).trigger('total:next')
			})
			.catch((error) => {
				$(document).trigger('message:error', { message: error })
			})
	}

	setLoading(bool) {
		if (bool) {
			this.$el.find('.mdc-select').addClass('mdc-select--disabled')
			this.select.attr('disabled', true)
			this.loader.removeClass('parcelshop__loader--hidden')
			$('parcelshop__info-overlay').removeClass(
				'parcelshop__info-overlay--hidden',
			)
		} else {
			this.$el.find('.mdc-select').removeClass('mdc-select--disabled')
			this.select.attr('disabled', false)
			this.loader.addClass('parcelshop__loader--hidden')
			$('parcelshop__info-overlay').addClass('parcelshop__info-overlay--hidden')
		}
	}
}
